import { Routes } from '@angular/router';
import { RouteNetworkPageComponent } from './route-network-page.component';
import { RouteNetworkTabsComponent } from './components/route-network-tabs/route-network-tabs.component';
import { RouteNetworkInformationTabComponent } from './components/route-network-information-tab/route-network-information-tab.component';
import { pendingChangesGuard } from '@core/guards/pending-changes.guard';

export const RouteNetworkRouteName = {
  Main: 'route-networks',
  Information: 'information',
};

export const ROUTE_NETWORK_ROUTES: Routes = [
  {
    path: '',
    component: RouteNetworkPageComponent,
    children: [
      {
        path: ':id',
        pathMatch: 'full',
        redirectTo: `:id/${RouteNetworkRouteName.Information}`,
      },
      {
        path: ':id',
        component: RouteNetworkTabsComponent,
        children: [
          {
            path: RouteNetworkRouteName.Information,
            component: RouteNetworkInformationTabComponent,
            canDeactivate: [
              (component: RouteNetworkInformationTabComponent) =>
                pendingChangesGuard(component),
            ],
          },
        ],
      },
    ],
  },
];
